// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductCompareCarouselStyles } from "@rpsc/Overrides/Widgets/ProductCompare/ProductCompareCarousel";
import IconArrowLeftLink from "@rpsc/XDL/Icons/IconArrowLeftLink";
import Close from "@rpsc/XDL/Icons/IconClose";
import { createLinkIconStyles, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

ProductCompareCarouselStyles.headerRemoveAllButton = {
    variant: "tertiary",
};

ProductCompareCarouselStyles.container = {
    offsetCss: css`
        margin-top: 0;
    `,
};

ProductCompareCarouselStyles.navigationLink = {
    icon: { iconProps: { src: IconArrowLeftLink, size: 12 } },
};

ProductCompareCarouselStyles.removeWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 30px;
        border-radius: 4px;
    `,
};

ProductCompareCarouselStyles.removeProductFromCompareClickable = {
    ...createLinkIconStyles(Close, {
        color: "text.main",
        icon: {
            iconProps: {
                color: "primary",
            },
        },
        css: css`
            span {
                margin: 0;
            }
        `,
    }),
};

ProductCompareCarouselStyles.headerTextGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        padding-bottom: 0;
        padding-top: 0;
        align-items: flex-end;
    `,
};

ProductCompareCarouselStyles.headerButtonsGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        padding-bottom: 0;
        justify-content: flex-end;
        align-items: flex-end;
        ${xScreen("lte", "sm")} {
            justify-content: flex-start;
        }
    `,
};

ProductCompareCarouselStyles.headerText = {
    variant: "h1",
    css: css`
        margin: 0;
    `,
};
